import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'cap-gwrcontainer',
  templateUrl: './gwrcontainer.component.html',
  styleUrls: ['./gwrcontainer.component.scss'],
  imports: [RouterOutlet]
})
export class GwrcontainerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
